import { render, staticRenderFns } from "./UserSettlementList.vue?vue&type=template&id=28b1e0fc&scoped=true&"
import script from "./UserSettlementList.vue?vue&type=script&lang=js&"
export * from "./UserSettlementList.vue?vue&type=script&lang=js&"
import style0 from "./UserSettlementList.vue?vue&type=style&index=0&id=28b1e0fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b1e0fc",
  null
  
)

export default component.exports